import { render } from "./uploadid.vue?vue&type=template&id=d2887d3a&class=bg-gray-00%20font-nunito"
import script from "./uploadid.vue?vue&type=script&lang=js"
export * from "./uploadid.vue?vue&type=script&lang=js"

import "./uploadid.vue?vue&type=style&index=0&id=d2887d3a&lang=css"
script.render = render

export default script